import React from 'react';
import "./header.css"
import TvIcon from '@material-ui/icons/Tv';


    const Header = () => {
    return (
        <span onClick = {() =>window.scroll(0 ,0)} className = "header"><b style={{fontSize:'35px'}}><TvIcon color='primary' size="100px"/> LitTv Plug </b> </span>
    )
}

export default Header
